<template>
  <b-container class="pl-0 pt-0 pb-2 pr-0">
    <b-row v-if="!newOnly && loading">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row v-if="!loading && hideNewField" class="text-left">
      <b-col>
        <b-form-group
          id="surveyRunSelectGroup"
          breakpoint="md"
          label="Scoring Event"
          label-for="surveyRunSelect"
          validated
        >
          <b-form-select
            v-model="selectedSurveyRun"
            :options="surveyRuns"
            class="mb-3"
            id="surveyRunSelect"
            @input="selectionMade($event)"
            @change="selectionMade($event)"
            :required="required"/>

        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!loading && hideNewField && !selectedSurveyRun && !noNew">
      <b-col class="text-left">
        <b-button variant="primary" @click="addNew()" v-if="hideNewField">Add New</b-button>
      </b-col>
    </b-row>

    <b-row v-show="hideNewField === false" class="text-left">
      <b-col>
        <b-form-group
          id="yearGroup"
          breakpoint="md"
          label="Year"
          label-for="year"
          validated
        >
          <b-form-select v-model="year" :options="years" class="mb-3" id="year" required/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && year" class="text-left">
      <b-col>
        <b-form-group
          id="periodGroup"
          breakpoint="md"
          label="Period"
          label-for="period"
          validated
        >
          <b-form-select v-model="period" :options="periodOptions" class="mb-3" id="period" required/>
        </b-form-group>
      </b-col>
    </b-row>
    <programme-selection v-model="programme" @update:programme="programme = $event;" v-show="!hideNewField && period"/>
    <customer-selection v-model="customerId" @update:customer="customerId = $event" v-show="!hideNewField && programme"/>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group
          id="staffGroup"
          breakpoint="md"
          label="Number of Staff"
          label-for="number_of_staff"
          validated
        >
          <b-form-input v-model="number_of_staff" type="number" id="number_of_staff"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="unitsGroup"
          breakpoint="md"
          label="Number of Units"
          label-for="number_of_units"
          validated
        >
          <b-form-input v-model="number_of_units" type="number" id="number_of_units"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="areaGroup"
          breakpoint="md"
          label="Areas"
          label-for="area"
          validated
        >
          <vue-tags-input :tags="areas" v-model="area" @tags-changed="newTags => areas = newTags" id="area"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="sponsorGroup"
          breakpoint="md"
          label="Sponsor"
          label-for="sponsor"
          validated
        >
          <b-form-input v-model="sponsor" id="sponsor"/> 
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="sponsorContactGroup"
          breakpoint="md"
          label="Sponsor Contact Number"
          label-for="sponsor_contact_number"
          validated
        >
          <b-form-input v-model="sponsor_contact_number" id="sponsor_contact_number"/> 
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="gatekeeperGroup"
          breakpoint="md"
          label="Gatekeeper"
          label-for="gatekeeper"
          validated
        >
          <b-form-input v-model="gatekeeper" id="gatekeeper"/> 
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="gatekeeperContactGroup"
          breakpoint="md"
          label="Gatekeeper Contact Number"
          label-for="gatekeeper_contact_number"
          validated
        >
          <b-form-input v-model="gatekeeper_contact_number" id="gatekeeper_contact_number"/> 
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-form-checkbox
        id="externalPoc"
        v-model="external_poc"
        value="true"
        unchecked-value="false"
        breakpoint="md"
        class="ml-4 mb-3 mt-2"
      >
        External POC
      </b-form-checkbox>
    </b-row>    


    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="accreditationsGroup"
          breakpoint="md"
          label="Accreditations"
          label-for="accreditations"
          validated
        >
          <wysiwyg v-model="accreditations" id="accreditations"/>   
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && customerId" class="text-left">
      <b-col>
        <b-form-group 
          id="customizationGroup"
          breakpoint="md"
          label="Customisation"
          label-for="customization"
          validated
        >
          <wysiwyg v-model="customization" id="customization"/>   
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="!hideNewField && !saving" class="pt-2">
      <b-col cols=6 class="text-left">
        <b-button variant="success" @click="save()" :disabled="!customerId">Save</b-button>
      </b-col>
      <b-col cols=6 class="text-right">
        <b-button variant="default" @click="cancelAdd()" v-show="!newOnly">Cancel</b-button>
      </b-col>
    </b-row>
    <b-row v-if="saving">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from '@/services/API'
import {industries, countries, getRegions} from '@/services/constants';
import CustomerSelection from '@/components/CustomerSelection.vue';
import ProgrammeSelection from '@/components/ProgrammeSelection.vue';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: 'SurveyRunSelection',
  components: {
    CustomerSelection,
    ProgrammeSelection,
    VueTagsInput
  },
  // properties you can pass to this component
  props: {
    customer: {
      default: null,
      type: Number
    },
    noNew: {
      default: false,
      type: Boolean
    },
    newOnly: {
      default: false,
      type: Boolean
    },
    surveyRunId: {
      default: null,
      type: Number
    },
    required: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    customer: {
      handler(newData) {
        this.filter();
      }
    },
    surveyRunId: {
      handler(newData) {
        this.filter();
      }
    }
  },
  data () {
    return {
      year: null,
      period: null,
      customerId: null,
      programme: null,
      number_of_staff: null,
      number_of_units: null,
      areas: [],
      area: '',
      sponsor: null,
      sponsor_contact_number: null,
      gatekeeper: null,
      gatekeeper_contact_number: null,
      external_poc: "false",
      accreditations: null,
      customization: null,
      years: [],
      periodOptions: ['CY','Q1', 'Q2', 'Q3', 'Q4', '1H', '2H', 'FY', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      surveyRuns: [],
      selectedSurveyRun: null,
      hideNewField: true,
      loading: true,
      saving: false,
      fullSurveyRuns: {}
    }
  },
  created () {
    const start = new Date().getFullYear() - 5;
    for (var i = 0; i <= 5; i++) {
      this.years.unshift(start + i);
    }
    this.fetchData();
    if (this.newOnly) this.hideNewField = false;
  },
  methods: {
    filter() {
      this.surveyRuns = Object.values(this.fullSurveyRuns)
        .filter(x => !this.customer || x.customer_id === this.customer)
        .map(surveyRun => ({
          value: surveyRun.id,
          text: `${surveyRun.programme.name} - ${surveyRun.customer.name} - ${surveyRun.period} ${surveyRun.year}`
        }));
      // sort descending by id so last added scoring event at top of sort list
      this.surveyRuns.sort((run1, run2) => {
        return run2.value - run1.value;
      });
      this.surveyRuns.unshift({ value: null, text: `Select a Scoring Event ${this.noNew ? '' : 'or Add New'}` });
      if (this.surveyRunId > 0) {
        this.selectedSurveyRun = this.surveyRunId;
        this.selectionMade(null);
      }
    },
    fetchData () {
      this.loading = true
      return API.getSurveyRuns().then(surveyRunResults => {
        // make the list for vue
        // also store for later
        const newFullSurveyRuns = {};
        surveyRunResults.results.forEach(fullSurveyRun => {
          newFullSurveyRuns[fullSurveyRun.id] = fullSurveyRun;
        });
        this.fullSurveyRuns = newFullSurveyRuns;
        if (this.surveyRunId > 0) {
          this.selectedSurveyRun = this.surveyRunId;
          this.selectionMade(null);
        }
        this.filter();
        this.loading = false;
      });
    },
    addNew () {
      this.hideNewField = false;
    },
    cancelAdd () {
      this.hideNewField = true;
    },
    save () {
      this.saving = true;
      const body = {
        programme_id: this.programme.value,
        customer_id: this.customerId,
        year: this.year,
        period: this.period,
        area: (this.areas || []).map(value => value.text).join(', '),
        sponsor: this.sponsor,
        sponsor_contact_number: this.sponsor_contact_number,
        gatekeeper: this.gatekeeper,
        gatekeeper_contact_number: this.gatekeeper_contact_number,
        external_poc: (this.external_poc === "true"),
        accreditations: this.accreditations,
        customization: this.customization,
        number_of_staff: this.number_of_staff,
        number_of_units: this.number_of_units
      }
      Object.keys(body).forEach(field => {
        if (!body[field]) delete body[field];
      });
      return API.addSurveyRun(body).then(response => {
        return this.fetchData().then(() => {
          Object.keys(body).forEach(field => this[field] = null);
          this.hideNewField = true
          this.selectedSurveyRun = response.body.surveyRunId;
          this.selectionMade();
          this.saving = false;
        })
      });
    },
    selectionMade (e) {
      this.$emit('update:surveyRun', {surveyRun: this.fullSurveyRuns[this.selectedSurveyRun]});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SurveyRunSelection.vue